
import {nextTick} from 'vue'
import LoginModal from '@library/components/Organisms/Modals/LoginModal.vue'
import LoginFormAdvantages from '@library/components/Organisms/Discovery/LoginFormAdvantages.vue'
import Links from '@library/components/Atoms/Link/Links.vue'
import ImageAtom from '@library/components/Atoms/Image/Image.vue'
import SubMenuItem from '@library/components/Molecules/Header/SubMenuItem.vue'
import SideNavLanguage from '@library/components/Molecules/Header/SideNavLanguage.vue'
import SideNavUser from '@library/components/Molecules/Header/SideNavUser.vue'
import SideNavContactUs from '@library/components/Molecules/Header/SideNavContactUs.vue'
import AdminRibbon from '@library/components/Molecules/Header/AdminRibbon.vue'
import SideNavCurrency from '@library/components/Molecules/Header/SideNavCurrency.vue'
export default {
  name: 'Header',
  components: {
    LoginModal,
    LoginFormAdvantages,
    Links,
    ImageAtom,
    SubMenuItem,
    SideNavLanguage,
    SideNavUser,
    SideNavContactUs,
    AdminRibbon,
    SideNavCurrency
  },
  data: () => ({
    akamaiCutting: '?output-quality=70',
    activeHamburger: false,
    activePhoneMenu: false,
    showDropdown: false,
    showDropdownTablet: false,
    showTelephonesListDsk: false,
    showTelephonesListTablet: false,
    headerTelephonesList: '',
    phoneObject: {
      telephone: '',
      countryCode: '',
      countryName: '',
      globalTelephone: ''
    },
    brandMicrosite: '',
    arraySupLinksBP: [],
    contracts: ['ELITE', 'MASTER', 'ADVANC', 'SMART'],
    activeMenu: {
      menu: null,
      user: false,
      language: false,
      contact: false
    },
    isOpen: {},
    isOpenSubMenuItem: false,
    openLoginModal: false,
    isOpenSidebar: false,
    isOpenSidebarOverlay: false,
    fixedMenu: false,
    lastMenu: null,
    lockedMenu: false,
    clickedOutside: false
  }),
  props: {
    exitButton: {
      type: Boolean,
      default: false
    },
    mobileTransparent: {
      type: Boolean,
      default: false
    },
    desktopTransparent: {
      type: Boolean,
      default: false
    },
    publicPath: {
      type: String,
      default: '/'
    },
    langDefault: {
      type: String,
      default: ''
    },
    langDefaultFlag: {
      type: String,
      default: ''
    },
    process: {
      type: Object,
      default: () => {}
    },
    isMicrosite: {
      type: Boolean,
      default: false
    },
    bd: {
      type: String,
      default: ''
    },
    brand: {
      type: String,
      default: 'nh'
    },
    telephones: {
      type: Array,
      default: () => []
    },
    telephoneContact: {
      type: Boolean,
      default: false
    },
    globalTelephone: {
      type: String,
      default: ''
    },
    defaultCountry: {
      type: String,
      default: ''
    },
    homeLink: {
      type: Object,
      default: () => {}
    },
    help: {
      type: Object,
      required: false,
      default: () => {}
    },
    login: {
      type: Object,
      default: () => {}
    },
    logo: {
      type: Object,
      default: () => {}
    },
    logoTransparent: {
      type: Object,
      default: () => {}
    },
    sections: {
      type: Array,
      default: () => []
    },
    languages: {
      type: Array,
      default: () => []
    },
    text: {
      type: Object,
      default: () => {}
    },
    isLogged: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object,
      default: () => {}
    },
    labels: {
      type: Object,
      default: () => {}
    },
    dataResetPassword: {
      type: Object,
      default: () => {}
    },
    globals: {
      type: Object,
      default: () => {}
    },
    errorLogin: {
      type: String,
      default: ''
    },
    fieldsErrors: {
      type: Object,
      default: () => ({})
    },
    resetPasswordFieldsErrors: {
      type: Object,
      default: () => ({})
    },
    resetPasswordSubmmited: {
      type: Boolean,
      default: false
    },
    baseUrl: {
      type: String,
      default: ''
    },
    lang: {
      type: String,
      default: ''
    },
    baseUrlLang: {
      type: String,
      default: ''
    },
    oneRow: {
      type: Boolean,
      default: true
    },
    showCurrency: {
      type: Boolean,
      default: false
    },
    errorReset: {
      type: Boolean,
      default: false
    },
    isBP: {
      type: Boolean,
      default: false
    },
    b2bData: {
      type: Object,
      default: () => ({})
    },
    currencyList: {
      type: Array,
      default: () => []
    },
    currencyDefault: {
      type: String,
      default: ''
    },
    currencyHotel: {
      type: String,
      default: 'EUR'
    },
    currencySetted: {
      type: Boolean,
      default: false
    },
    isKiosk: {
      type: Boolean,
      default: false
    },
    online: {
      type: Boolean,
      required: false,
      default: false
    },
    terminalId: {
      type: String,
      default: ''
    },
    hotelId: {
      type: String,
      default: ''
    },
    isInverted: {
      type: Boolean,
      default: false
    },
    isTransparent: {
      type: Boolean,
      default: false
    },
    isAbsolute: {
      type: Boolean,
      default: false
    },
    isGradientHeader: {
      type: Boolean,
      default: false
    },
    hideHelp: {
      type: Boolean,
      default: false
    },
    isOnlyLanguages: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isB2B() {
      let b2bRoleList = ['B2B_HOME', 'B2B_ADMIN']
      return b2bRoleList.includes(this.userData?.activeRol)
    },
    isResponsive() {
      return window.innerWidth <= 992
    },
    logoDesktop() {
      let logo = this.logo?.url
      if (this.desktopTransparent) {
        logo = this.logoTransparent?.url
      }
      return logo
    },
    logoMobile() {
      let logo = this.logo?.url
      if (this.mobileTransparent || this.isInverted) {
        logo = this.logoTransparent?.url
      }
      return logo
    },
    loginModalContent() {
      return this.login?.content?.modal?.content
    },
    shortName() {
      let sName = this.userData?.name ? this.userData?.name?.charAt(0).toUpperCase() : ''
      sName += this.userData?.lastName ? this.userData?.lastName?.charAt(0).toUpperCase() : ''
      return sName || 'NA'
    },
    category() {
      return this.userData?.category ? this.userData?.category.toLowerCase() : ''
    },
    categoryB2B() {
      const company = this.b2bData?.contrato ? this.b2bData?.contrato : ''
      if (!company) return null
      const contracts = this.contracts
      if (contracts.some(contract => company.includes(contract))) return company.toLowerCase()
    },
    isColor() {
      const element = {
        silver: 'icon-discovery is-silver',
        gold: 'icon-discovery is-gold',
        platinum: 'icon-discovery is-platinum',
        titanium: 'icon-discovery is-titanium',
        red: 'icon-discovery is-red',
        smart_web: 'icon-nhpro is-smart',
        advanc_web: 'icon-nhpro is-advance',
        master_web: 'icon-nhpro is-master',
        elite_web: 'icon-nhpro is-elite'
      }
      if (this.isB2B && this.categoryB2B) {
        return element[this.categoryB2B]
      } else if (this.category) {
        return element[this.category]
      } else if (this.isB2B && !this.categoryB2B) {
        return this.isCompany ? 'icon-nhpro no-category is-company' : 'icon-nhpro no-category'
      } else return 'icon-discovery'
    },
    isAdminLoggedUs() {
      if (this.userData?.activeRol == 'B2B_ADMIN' && this.userData?.loggedAs && this.userData?.loggedAs.name) return true
    },
    isCompany() {
      return this.b2bData?.type == 'CO'
    }
  },
  watch: {
    isLogged(val) {
      if (!val) {
        this.activeMenu['user'] = val
        this.isOpenSidebarOverlay = false
      }
      if (val) this.closeLogin()
    },
    currencyDefault(val) {
      if (this.isResponsive && val) {
        this.closeSidebar()
      } else {
        this.handleClickMenu('currency')
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleCloseBurgerMenu() {
      this.isOpenSidebar = !this.isOpenSidebar
      document.body.classList.remove('hamburger-menu-opened')
    },
    handleOpenBurgerMenu() {
      this.isOpenSidebar = !this.isOpenSidebar
      document.body.classList.add('hamburger-menu-opened')
    },
    handleMouseLeave() {
      if (!this.isResponsive && !this.fixedMenu) {
        this.showMenu(null)
      }
      if (!this.isResponsive) {
        this.unlockMenu()
      }
    },
    handleClickMenu(index) {
      if (!this.isResponsive) {
        this.fixMenu(index)
      }
      if (typeof index === 'number') {
        this.showMenu('menu', index)
      } else {
        this.showMenuOption(index)
      }
      if (!this.isResponsive && !this.fixedMenu) {
        this.showMenu(null)
      }
      if (!this.isResponsive) {
        this.lockMenu()
      }
    },
    handleMouseOver(index) {
      if (!this.isResponsive && !this.fixedMenu && !this.lockedMenu) {
        if (typeof index === 'number') {
          this.showMenu('menu', index)
        } else {
          this.showMenuOption(index)
        }
      }
      if (!this.isResponsive) {
        this.unlockMenu(index)
      }
    },
    handleClickOutside(event) {
      if (
        this.$refs.mainHeader &&
        !this.$refs.mainHeader.contains(event.target) &&
        ((this.$refs.userButton && !this.$refs.userButton.contains(event.target)) ||
          (!this.$refs.userButton && this.login && Object.keys(this.login).length === 0)) &&
        this.$refs.languageButton &&
        !this.$refs.languageButton.contains(event.target) &&
        ((this.$refs.currencyButton && !this.$refs.currencyButton.contains(event.target)) || !this.showCurrency) &&
        ((this.$refs.telephoneButton && !this.$refs.telephoneButton.contains(event.target)) ||
          !(this.telephones && this.globalTelephone) ||
          this.telephoneContact) &&
        !this.isResponsive
      ) {
        this.showMenu(null)
        this.clickedOutside = true
        this.fixedMenu = false
      } else {
        this.clickedOutside = false
      }
    },
    handleClickLogin(index) {
      if (this.isLogged) {
        this.user()
        this.lockMenu()
        this.fixMenu(index)
      } else {
        this.user()
        this.unlockMenu()
        this.fixedMenu = false
      }
    },
    fixMenu(key) {
      if (this.lastMenu === key) {
        this.fixedMenu = !this.fixedMenu
        this.lastMenu = key
      } else if (this.lastMenu === null) {
        this.fixedMenu = !this.fixedMenu
        this.lastMenu = key
      } else {
        this.fixedMenu = true
        this.lastMenu = key
      }
    },
    lockMenu() {
      this.lockedMenu = true
    },
    unlockMenu(key) {
      if (key !== this.lastMenu) {
        this.lockedMenu = false
      }
    },
    showMenuOption(key) {
      if (key && key === 'contact') {
        this.activeMenu.contact = false
        this.showMenu(key)
      } else if (key && key === 'language') {
        this.activeMenu.language = false
        this.showMenu(key)
      } else if (key && key === 'currency') {
        this.activeMenu.currency = false
        this.showMenu(key)
      } else if (key && key === 'user') {
        this.activeMenu.user = false
        this.showMenu(key)
      }
    },
    showMenu(key, val) {
      this.isOpen = val
      const oldMenu = this.activeMenu
      this.activeMenu = {
        menu: null,
        user: false,
        language: false,
        contact: false
      }
      if (key && key === 'menu') {
        this.activeMenu[key] = val
      } else {
        this.activeMenu[key] = !oldMenu[key]
        this.isOpenSidebarOverlay = key === 'contact'
      }
    },
    user() {
      if (this.isLogged) {
        this.showMenuOption('user')
        this.isOpenSidebarOverlay = true
        this.closeLogin()
      } else {
        this.showMenu(null)
        this.openLogin()
      }
    },
    openLogin() {
      this.openLoginModal = true
      this.$emit('openLoginModal', true)
    },
    closeLogin() {
      nextTick(() => {
        this.openLoginModal = false
      })
      this.$emit('openLoginModal', false)
    },
    closeSidebar(event) {
      this.showMenu(null)
    },
    closeMenu(event) {
      this.showMenu(null)
      document.body.classList.remove('hamburger-menu-opened')
      nextTick(() => {
        this.isOpenSidebar = false
      })
    },
    removeSlash(str) {
      return str?.replace(/\/$/, '')
    },
    changeLanguage(event) {
      this.$emit('changeLanguage', event)
    }
  }
}
